import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 48 48" style={{ flexShrink: 0 }}>
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
    </svg>
  );
}

function FacebookIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" style={{ flexShrink: 0 }}>
      <path fill="#fff" d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.97h-1.513c-1.491 0-1.956.93-1.956 1.886v2.267h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"/>
    </svg>
  );
}

const C = {
  trasporto: '#EB1C24',
  alloggio: '#0071BA',
  attivita: '#FF5B00',
  servizi: '#009045',
  dark: '#0a1628',
  white: '#ffffff',
  text: '#1a1a2e',
  textLight: '#6b7280',
  border: '#e5e7eb',
  light: '#f5f7fa',
};

const REDIRECT = window.location.hostname === 'localhost'
  ? 'http://localhost:3000/dashboard'
  : 'https://octaexp.com/dashboard';

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingOAuth, setLoadingOAuth] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const { error: err } = await supabase.auth.signInWithPassword({ email, password });
    if (err) {
      setError('Email o password non corretti. Riprova.');
    } else {
      navigate('/dashboard');
    }
    setLoading(false);
  };

  const handleOAuth = async (provider) => {
    setLoadingOAuth(provider);
    setError('');
    const options = { redirectTo: REDIRECT };
    await supabase.auth.signInWithOAuth({ provider, options });
    setLoadingOAuth('');
  };

  return (
    <div style={s.page}>
      <style>{`
        @font-face { font-family: 'Roboto'; src: url('/fonts/Roboto-Regular.ttf'); font-weight: 400; }
        @font-face { font-family: 'Roboto'; src: url('/fonts/Roboto-Medium.ttf'); font-weight: 500; }
        @font-face { font-family: 'Roboto'; src: url('/fonts/Roboto-Bold.ttf'); font-weight: 700; }
        @font-face { font-family: 'Roboto'; src: url('/fonts/Roboto-Black.ttf'); font-weight: 900; }
        * { font-family: 'Roboto', sans-serif; box-sizing: border-box; margin: 0; padding: 0; }
        a { text-decoration: none; }
        button:hover { opacity: 0.85; }
        input:focus { outline: none; border-color: ${C.alloggio} !important; }
        @media (max-width: 1024px) {
          .octa-header { padding: 12px 32px !important; }
          .octa-footer { padding: 20px 32px !important; }
        }
        @media (max-width: 640px) {
          .octa-header { padding: 12px 20px !important; }
          .octa-card-body { padding: 24px !important; }
          .octa-footer { padding: 20px 20px !important; flex-direction: column !important; align-items: flex-start !important; }
        }
      `}</style>

      {/* HEADER */}
      <header style={s.header} className="octa-header">
        <a href="/"><img src="/images/logo.png" alt="OCTA" style={s.logo} /></a>
        <div style={s.headerBtns}>
          <a href="/register" style={s.registerBtn}>Registrati</a>
        </div>
      </header>

      {/* FORM AREA */}
      <main style={s.main}>
        <div style={s.card}>
          {/* Barra colori brand */}
          <div style={s.colorBar}>
            {['trasporto', 'alloggio', 'attivita', 'servizi'].map(k => (
              <div key={k} style={{ ...s.colorBarItem, backgroundColor: C[k] }} />
            ))}
          </div>

          <div style={s.cardBody} className="octa-card-body">
            <div style={s.iconRow}>
              {[
                '/images/trasporto_icona.png',
                '/images/alloggio_icona.png',
                '/images/attivita_icona.png',
                '/images/servizi_icona.png',
              ].map((src, i) => (
                <img key={i} src={src} alt="" style={s.icon} />
              ))}
            </div>

            <h1 style={s.title}>Bentornato</h1>
            <p style={s.subtitle}>Accedi al tuo account OCTA</p>

            {/* SOCIAL LOGIN */}
            <div style={s.socialRow}>
              <button type="button" style={s.googleBtn} onClick={() => handleOAuth('google')} disabled={!!loadingOAuth}>
                <GoogleIcon />
                {loadingOAuth === 'google' ? 'Attendere...' : 'Continua con Google'}
              </button>
              <button type="button" style={s.facebookBtn} onClick={() => handleOAuth('facebook')} disabled={!!loadingOAuth}>
                <FacebookIcon />
                {loadingOAuth === 'facebook' ? 'Attendere...' : 'Continua con Facebook'}
              </button>
            </div>

            <div style={s.orRow}>
              <div style={s.orLine} />
              <span style={s.orText}>oppure</span>
              <div style={s.orLine} />
            </div>

            <form onSubmit={handleLogin} style={s.form}>
              <div style={s.fieldGroup}>
                <label style={s.label}>Email</label>
                <input
                  type="email"
                  placeholder="la-tua@email.com"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  style={s.input}
                  required
                />
              </div>

              <div style={s.fieldGroup}>
                <label style={s.label}>Password</label>
                <input
                  type="password"
                  placeholder="••••••••"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  style={s.input}
                  required
                />
              </div>

              {error && <div style={s.errorBox}>{error}</div>}

              <button type="submit" style={s.submitBtn} disabled={loading}>
                {loading ? 'Accesso in corso...' : 'Accedi →'}
              </button>
            </form>

            <div style={s.divider} />

            <p style={s.switchText}>
              Non hai ancora un account?{' '}
              <a href="/register" style={s.switchLink}>Registrati</a>
            </p>
          </div>
        </div>
      </main>

      {/* FOOTER */}
      <footer style={s.footer} className="octa-footer">
        <img src="/images/logo_bianco.png" alt="OCTA" style={s.footerLogo} />
        <p style={s.footerText}>© 2025 OCTA — Online Complete Travel Agency</p>
        <div style={s.footerDots}>
          {['trasporto', 'alloggio', 'attivita', 'servizi'].map(k => (
            <span key={k} style={{ ...s.footerDot, backgroundColor: C[k] }} />
          ))}
        </div>
      </footer>
    </div>
  );
}

const s = {
  page: { backgroundColor: C.light, minHeight: '100vh', display: 'flex', flexDirection: 'column', color: C.text },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 60px', backgroundColor: C.white, position: 'sticky', top: 0, zIndex: 100, borderBottom: `1px solid ${C.border}` },
  logo: { height: '36px', objectFit: 'contain' },
  headerBtns: { display: 'flex', gap: '12px' },
  registerBtn: { padding: '10px 24px', borderRadius: '8px', backgroundColor: C.alloggio, color: C.white, fontSize: '14px', fontWeight: 700 },
  main: { flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '60px 20px' },
  card: { width: '100%', maxWidth: '440px', backgroundColor: C.white, borderRadius: '20px', border: `1px solid ${C.border}`, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', overflow: 'hidden' },
  colorBar: { display: 'flex', height: '5px' },
  colorBarItem: { flex: 1 },
  cardBody: { padding: '40px' },
  iconRow: { display: 'flex', gap: '12px', marginBottom: '28px' },
  icon: { height: '28px', objectFit: 'contain' },
  title: { fontSize: '28px', fontWeight: 900, color: C.text, marginBottom: '8px' },
  subtitle: { fontSize: '14px', color: C.textLight, marginBottom: '32px' },
  form: { display: 'flex', flexDirection: 'column', gap: '18px' },
  fieldGroup: { display: 'flex', flexDirection: 'column', gap: '6px' },
  label: { fontSize: '13px', fontWeight: 600, color: C.text },
  input: { padding: '13px 16px', borderRadius: '4px', border: `1px solid ${C.border}`, fontSize: '15px', backgroundColor: '#fafafa', color: C.text, transition: 'border-color 0.2s' },
  errorBox: { padding: '12px 16px', backgroundColor: '#fff5f5', border: `1px solid #fecaca`, borderRadius: '8px', fontSize: '13px', color: '#dc2626' },
  submitBtn: { padding: '15px', borderRadius: '10px', backgroundColor: C.alloggio, color: C.white, fontSize: '15px', fontWeight: 700, border: 'none', cursor: 'pointer', marginTop: '4px' },
  divider: { height: '1px', backgroundColor: C.border, margin: '24px 0' },
  switchText: { fontSize: '14px', color: C.textLight, textAlign: 'center' },
  switchLink: { color: C.alloggio, fontWeight: 700 },
  socialRow: { display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '4px' },
  googleBtn: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '13px 16px', borderRadius: '10px', border: `1px solid ${C.border}`, backgroundColor: C.white, color: C.text, fontSize: '14px', fontWeight: 600, cursor: 'pointer', width: '100%' },
  facebookBtn: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '13px 16px', borderRadius: '10px', border: 'none', backgroundColor: '#1877F2', color: C.white, fontSize: '14px', fontWeight: 600, cursor: 'pointer', width: '100%' },
  orRow: { display: 'flex', alignItems: 'center', gap: '12px', margin: '20px 0' },
  orLine: { flex: 1, height: '1px', backgroundColor: C.border },
  orText: { fontSize: '12px', color: C.textLight, fontWeight: 500, whiteSpace: 'nowrap' },
  footer: { padding: '24px 60px', borderTop: `1px solid ${C.border}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: C.dark, flexWrap: 'wrap', gap: '16px' },
  footerLogo: { height: '28px', objectFit: 'contain' },
  footerText: { fontSize: '13px', color: 'rgba(255,255,255,0.4)' },
  footerDots: { display: 'flex', gap: '8px' },
  footerDot: { width: '10px', height: '10px', borderRadius: '50%' },
};
